import { addHours } from 'date-fns'

import { OlympusClient } from '@/OlympusClient'
import store from '@/store'

import { OTC_EXPIRATION_HOURS } from '../../constants'
import { type CampaignResource, type CampaignResourceUpdate } from '../types'

import { fetchResource } from './fetchEmailData'

export const updateResourceHandler = async (
  campaignId: string,
  { subject, name, sections, executeAt, locationId }: CampaignResourceUpdate
): Promise<CampaignResource> => {
  const { emailTemplateId } = store.getters[
    'emailBuilder/currentResource'
  ] as unknown as CampaignResource

  const executeAtDate = executeAt ? new Date(executeAt) : null

  await Promise.all([
    OlympusClient.notifications.v1.templates.emails.email.updateEmailTemplate({
      body: { name, sections, subject },
      params: { emailTemplateId },
    }),
    OlympusClient.marketing.v1.campaigns.campaign.updateCampaign({
      body: {
        executeAt: executeAtDate ? executeAtDate.toISOString() : null,
        expiresAt: executeAtDate
          ? addHours(executeAtDate, OTC_EXPIRATION_HOURS).toISOString()
          : null,
        locationId,
        name,
      },
      params: { campaignId },
    }),
  ])

  const { resource } = await fetchResource(campaignId)

  return resource
}
